import React from "react";
const AppActions = () => {
  return (
    <div id={"app-actions"}>
      <h3 id={"app-actions"}>App Actions</h3>

      <div className={"imageContainer"}>
        <img src="/images/app_actions.png" alt="App Actions" />
      </div>

      <p>
        The App Actions toolbox category contains blocks that perform actions specific to a SOTI Snap app. These blocks allow you to control navigation, reset forms, open external apps or browsers, and manage page behaviour.
      </p>

      <ul>
        <li>
          <b>Close app</b> - Closes the current Snap app.
        </li>
        <br />
        <li>
          <b>Display a page in a gridview</b> - Puts the selected page inside a gridview container.
        </li>
        <br />
        <li>
          <b>Navigate to page</b> - Sends users to the specified page in the Snap app.
        </li>
        <br />
        <li>
          <b>Navigate back</b> - Returns the user to the previous page they were on.
        </li>
        <br />
        <li>
          <b>Reset form</b> - Clears all data from the selected form and resets it.
        </li>
        <br />
        <li>
          <b>Open browser</b> - Launches the device’s default browser or SOTI Surf with the specified URL.
        </li>
        <br />
        <li>
          <b>Set focus</b> - Moves the focus to a selected widget on the page. Can be used to help users fill out forms more quickly by moving the cursor to the next item in a form.
        </li>
        <br />
        <li>
          <b>Reload current page</b> - Refreshes the page the user is currently on.
        </li>
        <br />
        <li>
          <b>Reload specific page</b> - Refreshes a selected page.
        </li>
        <br />
        <li>
          <b>Open app</b> - Opens the app with the specified iOS/Android URI or Android package name.
        </li>
        <br />
        <li>
          <b>Open Snap app via URI</b> - Launches the Snap app with the specified URI.
        </li>
      </ul>

    </div>
  );
};

export default AppActions;
